import * as React from "react";
import { Stack, Typography, Box } from "@mui/material";
import {
    Description,
    AssignmentOutlined,
} from "@mui/icons-material";

type Props = {
    type?: string | null;
    documentKind?: string | null;
    size?: "small" | "medium";
};

export const DocumentAvatar: React.FC<Props> = ({
    type,
    documentKind,
    size = "small",
}) => {
    const kind = (documentKind ?? "NORMAL").trim().toUpperCase();
    const docType = (type ?? "").trim().toUpperCase();

    const Icon =
        kind === "PROTOCOL"
            ? AssignmentOutlined
            : Description;

    const iconSize = size === "small" ? "small" : "medium";

    return (
        <Stack
            spacing={0.5}
            alignItems="center"
            sx={{
                width: size === "small" ? 44 : 56,
                flexShrink: 0,
                color: "action.active",
            }}
        >
            {/* Szare tło tylko pod ikoną i typem */}
            <Stack
                spacing={0.25}
                alignItems="center"
                justifyContent="center"
                sx={{
                    width: "100%",
                    boxSizing: "border-box",
                    py: 0.75,
                    px: 0.25,
                    borderRadius: 1,
                    bgcolor: (theme) =>
                        theme.palette.mode === "dark"
                            ? "#2B3038"
                            : "#F1F3F5",
                }}
            >
                <Icon fontSize={iconSize} />

                {docType && (
                    <Typography
                        variant="caption"
                        sx={{
                            fontWeight: 800,
                            lineHeight: 1.2,
                            textAlign: "center",
                            letterSpacing: ".04em",
                            overflowWrap: "anywhere",
                            maxWidth: "100%",
                        }}
                    >
                        {docType}
                    </Typography>
                )}
            </Stack>

            {/* Rodzaj pod szarym tłem */}
            {kind && (
                <Box
                    component="span"
                    sx={{
                        px: 0.75,
                        borderRadius: 0.75,
                        border: "1px solid",
                        borderColor: "divider",
                        fontSize: "0.6rem",
                        fontWeight: 800,
                        lineHeight: 1.2,
                        textAlign: "center",
                        whiteSpace: "nowrap",
                    }}
                >
                    {kind}
                </Box>
            )}
        </Stack>
    );
};